module.exports = __webpack_public_path__ + "ec7c06e5b5dedb713f1c5958dc7c9f87.svg";